import { BreakingNewsWrapper } from './breakingNewsWrapper';

const props = [];

export const BreakingNewsViewDirective = reactDirective => reactDirective(BreakingNewsWrapper, props);
BreakingNewsViewDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('breakingNewsView', BreakingNewsViewDirective);
